import { Regexxgw0gjiagf4z as Regex } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _LanguageCode___init__impl__2a1w64(asString) {
  return asString;
}
function _LanguageCode___get_asString__impl__lnz35y($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.enUS_1 = _LanguageCode___init__impl__2a1w64('en-US');
        this.languagePattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[A-Za-z]{2,8}');
        this.extlangPattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[A-Za-z]{3}');
        this.scriptPattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[A-Za-z]{4}');
        this.regionPattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[A-Za-z]{2}|[0-9]{3}');
        this.variantPattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[A-Za-z0-9]{5,8}|[0-9][A-Za-z0-9]{3}');
        this.singletonPattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[0-9A-WY-Za-wy-z]');
        this.extensionSubtagPattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[A-Za-z0-9]{2,8}');
        this.privateUseSubtagPattern_1 = Regex().new_kotlin_text_Regex_acuq4a_k$('[A-Za-z0-9]{1,8}');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.kiteui.locale.LanguageCode', this);
        tmp0_serialDesc.addElement_5pzumi_k$('asString', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_3tn9xr_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeString_424b5v_k$(_LanguageCode___get_asString__impl__lnz35y(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3tn9xr_k$(encoder, value instanceof LanguageCode() ? value.asString_1 : THROW_CCE());
      }
      deserialize_aw41hs_k$(decoder) {
        return _LanguageCode___init__impl__2a1w64(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (LanguageCode())(this.deserialize_aw41hs_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function LanguageCode__toString_impl_suzjrw($this) {
  return 'LanguageCode(asString=' + $this + ')';
}
function LanguageCode__hashCode_impl_73tmz1($this) {
  return getStringHashCode($this);
}
function LanguageCode__equals_impl_b2aqc7($this, other) {
  if (!(other instanceof LanguageCode()))
    return false;
  if (!($this === other.asString_1))
    return false;
  return true;
}
var LanguageCodeClass;
function LanguageCode() {
  if (LanguageCodeClass === VOID) {
    class $ {
      constructor(asString) {
        Companion_getInstance();
        this.asString_1 = asString;
      }
      toString() {
        return LanguageCode__toString_impl_suzjrw(this.asString_1);
      }
      hashCode() {
        return LanguageCode__hashCode_impl_73tmz1(this.asString_1);
      }
      equals(other) {
        return LanguageCode__equals_impl_b2aqc7(this.asString_1, other);
      }
    }
    initMetadataForClass($, 'LanguageCode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    LanguageCodeClass = $;
  }
  return LanguageCodeClass;
}
//region block: exports
export {
  LanguageCode as LanguageCode15w5ectz557tc,
  _LanguageCode___init__impl__2a1w64 as _LanguageCode___init__impl__2a1w642yl3nbtrv09kx,
};
//endregion

//# sourceMappingURL=models.mjs.map
